import React, { Component, useEffect, useState } from 'react';
import { Progress } from 'antd';
import { createPreset, getImageUrlPreset, putImageToS3 } from '../../../apis/presetApi';
import useLogout from '../../../hooks/useLogout';
// import { createSwatch, getImageUrlSwatch, putImageToS3 } from '../../apis/swatchApi';

const thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 16,
};

const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: 'border-box',
};

const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
};

const img = {
    width: '200px',
    height: '300px',
};
export default function SingleFileUpload({ file, editPresetId, completedRef, failedRef, list, callFetcher, setCompleteCount }) {
    const [progress, setProgress] = useState(0);
    const [isComplete, setIsComplete] = useState(false);
    const [isFailed, setIsFailed] = useState(false);
    const { logout } = useLogout();

    useEffect(() => {
        getImageUrlPreset(file.name)
            .then(res => {
                const { url, key } = res;
                putImageToS3(url, file, setProgress)
                    .then(res => {
                        let obj = {
                            anglePresetId: editPresetId,
                            image: {
                                imagePath: {
                                    key: key,
                                },
                            },
                        };
                        createPreset(obj)
                            .then(res => {
                                setIsComplete(true);
                                setProgress(100);
                                setCompleteCount(prev => prev + 1);
                            })
                            .catch(err => {
                                console.log(err);
                            });
                    })
                    .catch(err => {
                        console.log(err);
                    });
            })
            .catch(err => {
                console.log(err);
                setIsFailed(true);
                failedRef.current += 1;
                if (err?.response?.status === 401) logout();
            });
    }, []);
    const handleApiCallSuccess = () => {
        console.log('API call successful in child component');
        callFetcher(); // Invoke the callback in the parent component
        // Other actions after a successful API call
    };

    return (
        <div>
            <div style={thumb} key={file.name}>
                <div style={thumbInner}>
                    <img
                        src={file.preview}
                        style={img}
                        // Revoke data uri after image is loaded
                        onLoad={() => {
                            URL.revokeObjectURL(file.preview);
                        }}
                    />
                    <p className="text-overflow" style={{ width: '150px', whiteSpace: 'nowrap' }}>
                        {file.name}
                    </p>
                </div>
            </div>
            <p className="text-overflow" style={{ width: '150px', whiteSpace: 'nowrap' }}>
                {file.name}
            </p>
            <Progress percent={progress} size="small" status={isFailed ? 'exception' : 'normal'} />
        </div>
    );
}
